export default __webpack_public_path__ + "static/char-v-sp01-109b2fa7e435a74cd878a3ee4807d5c6.mp4";